/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import axiosConfig, { ApiRequestType } from 'axiosConfig/axiosConfig';
import { UserPreferencesObject } from 'jotai/userPreferences';
import {
  DefaultWorkspaceResponse,
  SanctioningBodyEnum,
  UserPreferenceResponse,
  UserPreferenceResponseStatus,
  Workspace,
} from 'models/viewModels';

class UserPreferencesApi {
  async getUserPreferences(): Promise<UserPreferenceResponse> {
    const response = new Promise<UserPreferenceResponse>((resolve, reject) => {
      axiosConfig(ApiRequestType.MotorsportsCompToolsApi)
        .get('/rest/user/userPreference')
        .then((res) => resolve(res.data))
        .catch((error) => {
          reject(error);
        });
    });
    return response;
  }

  async updateUserPreferences(userPreferences: UserPreferencesObject): Promise<UserPreferenceResponseStatus> {
    const response = new Promise<UserPreferenceResponseStatus>((resolve, reject) => {
      axiosConfig(ApiRequestType.MotorsportsCompToolsApi)
        .post('/rest/user/userPreference', JSON.stringify(userPreferences))
        .then((res) => resolve(res.data))
        .catch((error) => {
          reject(error);
        });
    });
    return response;
  }

  async getDefaultWorkspaces(): Promise<DefaultWorkspaceResponse> {
    const response = new Promise<DefaultWorkspaceResponse>((resolve, reject) => {
      axiosConfig(ApiRequestType.MotorsportsCompToolsApi)
        .get('/rest/user/defaultWorkspaces')
        .then((res) => resolve(res.data))
        .catch((error) => {
          reject(error);
        });
    });
    return response;
  }

  async getDefaultWorkspace(sanctioningBody: SanctioningBodyEnum): Promise<Workspace | undefined> {
    const response = new Promise<Workspace | undefined>((resolve, reject) => {
      axiosConfig(ApiRequestType.MotorsportsCompToolsApi)
        .get('/rest/user/defaultWorkspace', {
          params: { sanctioningBody: sanctioningBody },
        })
        .then((res) => resolve(res.data))
        .catch((error) => {
          reject(error);
        });
    });
    return response;
  }
}

export const userPreferencesApi = new UserPreferencesApi();
